import React from 'react';
import { Link as GatsbyLink } from 'gatsby';

function Link(props) {
  const { to } = props;
  const newProps = { ...props, to: to.replace('dsw-new/', '') };
  return <GatsbyLink {...newProps} />;
}

export default Link;
